<script lang="ts">
  import Input from '../../../components/input/Input.svelte'
  import i18n from '../../../i18n'
  import { ChevronDown, CircleCheck } from '@lucide/svelte'
  import IconButton from '../../../components/icon-button/IconButton.svelte'
  import { DropdownContainer, DropdownTrigger, DropdownContent, DropdownItem } from '../../../components/dropdown'
  import { useProjectQueries } from '../../../hooks/project'

  let isEditable = $state(false)
  let formElement: HTMLFormElement

  const { useProjectQuery, updateProjectNameMutation } = useProjectQueries()
  const getProjectQuery = useProjectQuery()
  const project = $derived(getProjectQuery.data?.data)

  function handleSubmit(event: SubmitEvent) {
    event.preventDefault()
    const formData = new FormData(event.currentTarget as HTMLFormElement)
    const name = formData.get('name') as string

    if (!isEditable) isEditable = true
    else if (name === project?.name) isEditable = false
    else updateProjectNameMutation.mutate(name)
  }

  function handleClick() {
    isEditable = true
    setTimeout(() => {
      const input = formElement.elements.namedItem('name') as HTMLInputElement

      input.focus()
      input.select()
    }, 100)
  }

  $effect(() => {
    if (updateProjectNameMutation.isSuccess) {
      isEditable = false
      updateProjectNameMutation.reset()
    }
  })
</script>

<DropdownContainer>
  <DropdownTrigger class="project-name-user-infos">
    <form bind:this={formElement} class="container" onsubmit={handleSubmit}>
      {#if isEditable}
        <Input
          name="name"
          autocomplete="off"
          autofocus
          defaultValue={project?.name}
          disabled={updateProjectNameMutation.isPending}
          label={$i18n.t('project.name')}
          onclick={updateProjectNameMutation.reset}
          readonly={updateProjectNameMutation.isPending}
          variant="ghost"
        />
        <IconButton iconSize={1.25} size={2} type="submit">
          <CircleCheck size={16} />
        </IconButton>
      {:else}
        <div class="project-name">
          {project?.name}
        </div>
        <IconButton iconSize={1.25} size={2} type="button">
          <ChevronDown size={16} />
        </IconButton>
      {/if}
    </form>
  </DropdownTrigger>
  <DropdownContent placement="bottom-end">
    <DropdownItem href="/projects">
      {$i18n.t('navbar.dropdown.backToProjects')}
    </DropdownItem>
    <DropdownItem onclick={handleClick}>
      {$i18n.t('navbar.dropdown.renameProject')}
    </DropdownItem>
  </DropdownContent>
</DropdownContainer>

<style lang="scss">
  :global(.project-name-user-infos) {
    .container {
      display: flex;
      align-items: center;
      flex-direction: row;
      justify-content: space-between;
      color: var(--muted-foreground);
      padding: 0 1rem;
      flex: 1;

      .project-name {
        color: var(--foreground);
        flex: 1;
        text-align: start;
      }
    }
  }
</style>
